import {
  LOGOUT,
  NOTIFICATION_RECEIVED,
  SSE_CONNECTED,
  SSE_CONNECTING,
  SSE_DISCONNECTED,
  SSE_ERROR,
  CLEAR_SSE_NOTIFICATIONS,
  MARK_ALL_SSE_READ,
  MARK_SSE_NOTIFICATION_READ,
  REMOVE_SSE_NOTIFICATION,
} from "../ActionTypes";

const initialState = {
  status: "disconnected",
  notifications: [],
  lastError: null,
};

export const sseNotifications = (state = initialState, action) => {
  let newState;

  switch (action.type) {
    case SSE_CONNECTING:
      newState = { ...state, status: "connecting", lastError: null };
      break;

    case SSE_CONNECTED:
      newState = { ...state, status: "connected" };
      break;

    case SSE_DISCONNECTED:
      newState = { ...state, status: "disconnected" };
      break;

    case SSE_ERROR:
      newState = { ...state, status: "error", lastError: action.payload };
      break;

    case NOTIFICATION_RECEIVED: {
      const notification = action.payload;
      if (!notification?.id) {
        newState = state;
        break;
      }

      const existingIndex = state.notifications.findIndex(
        (n) => n.id === notification.id,
      );
      if (existingIndex >= 0) {
        newState = {
          ...state,
          notifications: state.notifications.map((item, index) =>
            index === existingIndex ? { ...item, ...notification } : item,
          ),
        };
        break;
      }

      newState = {
        ...state,
        notifications: [notification, ...state.notifications],
      };
      break;
    }

    case CLEAR_SSE_NOTIFICATIONS:
      newState = { ...state, notifications: [] };
      break;

    case LOGOUT:
      newState = initialState;
      break;

    case MARK_ALL_SSE_READ:
      newState = {
        ...state,
        notifications: state.notifications.map((notification) => ({
          ...notification,
          isRead: true,
          readAt: notification.readAt ?? new Date().toISOString(),
        })),
      };
      break;

    case MARK_SSE_NOTIFICATION_READ: {
      const notificationId = action.payload;
      newState = {
        ...state,
        notifications: state.notifications.map((notification) =>
          notification.id === notificationId
            ? {
                ...notification,
                isRead: true,
                readAt: notification.readAt ?? new Date().toISOString(),
              }
            : notification,
        ),
      };
      break;
    }

    case REMOVE_SSE_NOTIFICATION: {
      const notificationId = action.payload;
      newState = {
        ...state,
        notifications: state.notifications.filter((n) => n.id !== notificationId),
      };
      break;
    }

    default:
      newState = state;
  }

  return newState;
};
